export default Object.freeze({
    PENDING_VALIDATION: 'PENDING_VALIDATION',
    REGISTERED_USER: 'REGISTERED_USER',
    REGISTERED_DEMO_USER: 'REGISTERED_DEMO_USER',
    INVITED_USER: 'INVITED_USER',
})
